import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const PrivacyBanner = React.lazy(() => import("@mediaspace/features/privacy-banner"));

export const render = getStandaloneComponentRenderer(PrivacyBanner, true);

export { PrivacyBanner as Component };
